<script lang="ts">
  import actions from "./buttonActions"
  import buttonsDefinitions from "./buttons"

  export let button: any
  export let editor: any

  const but = buttonsDefinitions[button]
  const action = actions[button]
  // Simplified reactive state
  let active = false
  $: {
    active = editor?.isActive(button) || false
  }
</script>

{#if but && action}
  <div class="group relative">
    <button
      type="button"
      on:click={() => action(editor)()}
      class="border rounded-md text-gray-400 bg-gray-100 p-1 hover:bg-gray-200 hover:text-gray-600"
      class:bg-gray-300={active}
      class:text-gray-700={active}
    >
      <svelte:component this={but.icon} class="icon-size size-4" />
    </button>
  </div>
{/if}
